import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  OnDestroy
} from '@angular/core';
import { OsusumeCategoryList } from '../../models/plan/osusume';
import { OsusumeService } from '../../services/osusume.service';
import { Subject } from 'rxjs';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-osusume-dropdown',
  templateUrl: './osusume-dropdown.component.html',
  styleUrls: ['./osusume-dropdown.component.css']
})
export class OsusumeDropdownComponent implements OnInit, OnDestroy {
  public kyotenCd: string;
  public listCategory = [];
  ngUnsubscribe = new Subject();
  @Input('emptyOption') emptyOption = false;
  @Input('setDefault') categoryNo:number;
  @Output('onChangePlanName') onChangePlanName: any = new EventEmitter<number>();

  constructor(private osusumeSv: OsusumeService, private _data: DataService) {}

  ngOnInit() {
    this.kyotenCd = this._data.kyotenCd;
    if (this.osusumeSv.listCategory && this.kyotenCd === this.osusumeSv.kyotenCd) {
      this.listCategory = this.osusumeSv.listCategory;
    } else {
      this.getCategory();
    }

    this.osusumeSv.loadCategory
      .takeUntil(this.ngUnsubscribe)
      .subscribe(isLoad => {
        if (isLoad) {
          this.getCategory();
        }
      });
  }

  getCategory() {
    this.osusumeSv
      .getCategory(this.kyotenCd)
      .subscribe((data: OsusumeCategoryList) => {
        if (data) {
          this.listCategory = this.osusumeSv.setCategoryArray(data);
          this.osusumeSv.listCategory = this.listCategory;
        }
      });
  }

  onChange(value) {
    this.onChangePlanName.emit(value);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/osusume/osusume-dropdown/osusume-dropdown.component.ts